export default __webpack_public_path__ + "static/restaurant_1-d7ab7fb09d980e66b1a6d5297124b475.webp";